import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@mui/material';
import { createEnvironment } from '../../api/documentAPI';
import { generateChromaName } from '../../services/generateEnvironmentName';
import { getEnvironments, deleteEnvironment } from '../../api/documentAPI';
import { useAtom } from 'jotai';
import { allowDeleteAtom } from '../../atoms/useAllowDeleteAtom';
import useCookie from "../../hooks/useCookie";

const EnvironmentsList = ({ onEnvItemClick }) => {
    const [t, ] = useTranslation('global');
    const [envCookie , setCookie, ] = useCookie("ENV");
    const [msg, setMsg] = useState('');
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [selectedEnvId, setSelectedEnvId] = useState(null);
    const [environments, setEnvironments] = useState([]);
    const [allowDelete, setAllowDelete] = useAtom(allowDeleteAtom);
    const [formData, setFormData] = useState({name: '', folderName: '', roleId: ''});

    const fetchEnvironments = () => {
        getEnvironments()
        .then((data) => {
            setEnvironments(data);    
            if(!selectedEnvId) {
                setSelectedEnvId(data[0].Id);
            } 
        })
    }

    useEffect(() => {
        fetchEnvironments();
    }, []);

    const handleOpen = () => setOpen(true);
    
    const handleClose = () => setOpen(false);

    const handleEnvItemClick = (id) => {      
        setSelectedEnvId(id);
        onEnvItemClick(id);      
    }   

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    } 

    const handleAllowDelete = () => {
        setAllowDelete((prevAllowDelete) => !prevAllowDelete);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!formData.name || formData.name.trim() === '' || formData.name.length < 3 || formData.name.length > 63) {
            setErrorMessage(t('envNameRuleMsg'));
            setIsLoading(false);
            return;
        }

        let chromaName = generateChromaName(JSON.stringify(formData.name));
        let payload = {
            "Name": formData.name,
            "FolderName": chromaName,
            "RoleId": 1
        };

        createEnvironment(payload)
            .then(res => {
                console.log(res);
                setSelectedEnvId(res.Id);
                fetchEnvironments();
                
                setIsLoading(false);
                setFormData({name: '', folderName: '', roleId: ''});
                handleClose(); 
            });
    }

    const handleEnvironmentCookie = (id) => {
        if (JSON.parse(envCookie) === id) {
            let envId = JSON.stringify(environments[0].Id);
            setCookie("ENV", envId); 
        }
        else {
            return;
        }
    }

    const handleDeleteEnvironment = (id) => {
        setIsLoading(true);
        
        deleteEnvironment(id)
            .then(res => {
                fetchEnvironments();
                handleEnvironmentCookie(id);
            })
            .catch(err => {
                console.log(err);
                setIsLoading(false);
            })
            .finally(() => {
                setIsLoading(false);            
                setMsg(t('folderDeleted'));
            })        
    } 
    
    return (
        <>
            <div id="env-manager-btns" className='env-manager'>
                <div className="btn-group" onClick={handleOpen}>
                    <span className="material-symbols-outlined env-icon">add</span>
                    <span className="btn-description">{t('add')}</span>
                </div>

                <div className="btn-group" onClick={handleAllowDelete}>
                    <span className="material-symbols-outlined env-icon">do_not_disturb_on</span>
                    <span className="btn-description">{t('delete')}</span>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="env-modal-title"
                aria-describedby="env-modal-description"
            >
                <div className='env-form-wrapper'>
                    <div className='new-env-title'><h1>{t('newEnvironment')}</h1></div>
                    <form>
                        <input type="text" id="name-inp" name="name" 
                            value={formData.name} onChange={handleChange}
                        />
                        <button type="button" id="new-env-close" className='return-button' disabled={isLoading} onClick={handleClose}>
                            Close
                        </button>
                        <button type="submit" id="new-env-submit" className='submit-button' disabled={isLoading} onClick={handleSubmit}>
                            Create
                        </button>
                        {errorMessage ? <div className="new-env-message">{errorMessage}</div> : ''}
                    </form>
                </div>
            </Modal>
         
        <div className="tabs-wrapper">
            <div className="tabs">
            {environments.map((env) => (
                <React.Fragment key={env.Id}>
                    <div className="one-tab">
                        <input 
                            type='radio'
                            id={env.Id}
                            name="tabs"
                            defaultChecked={env.Id === selectedEnvId}
                            onClick={()=> handleEnvItemClick(env.Id)}
                        />
                        <label className="tab" htmlFor={`${env.Id}`}>
                        {env.Name}      
                        </label>
                        {allowDelete ? 
                            <span className="material-symbols-outlined" onClick={() => handleDeleteEnvironment(env.Id)}>
                                close
                            </span>
                        : null }         
                                               
                    </div>
                </React.Fragment>
            ))}
            </div>
        </div>
        {msg && 
            <div className='success-msg'> 
                { msg }  
            </div>
        }               
        </>
    );
}

export default EnvironmentsList;